// extracted by mini-css-extract-plugin
export default {"overlay":"CalendarRange_overlay__6pKrM","body":"CalendarRange_body__UPYuS"};